import type {
  EvaluatedFeatureFlag,
  EvaluteFeatureFlagsResponse,
} from "@b2bportal/commbank-au-feature-flags-api";
import { trackEvent, axiosInstance } from "@hopper-b2b/api";
import {
  type ExperimentsType,
  type IApiConfig,
  NETWORK_CALL_FAILED,
} from "@hopper-b2b/types";
import type { FeatureFlagsContext } from "../FeatureFlagsProvider";
import { featureFlagApiPrefix } from "./paths";

export const postFetchFeatureFlags = async (
  config?: IApiConfig,
  abortController?: AbortController
): Promise<FeatureFlagsContext> => {
  const featureFlagPrefix = featureFlagApiPrefix;
  const END_POINT = `${featureFlagPrefix}/evaluate`;

  try {
    const res = await axiosInstance.post<EvaluteFeatureFlagsResponse>(
      END_POINT,
      {},
      { signal: abortController?.signal }
    );

    const { evaluatedFeatureFlags: featureFlags, ...rest } = res.data;

    const experiments: ExperimentsType = featureFlags?.reduce(
      (map: ExperimentsType, featureFlag: EvaluatedFeatureFlag) => {
        map[featureFlag.featureFlagName] = featureFlag.variant;
        return map;
      },
      {}
    );

    return {
      featureFlags,
      experiments,
      ...rest,
    };
  } catch (e) {
    trackEvent(
      {
        eventName: NETWORK_CALL_FAILED,
        properties: {
          url: window.location.pathname,
        },
      },
      config
    );
    throw e;
  }
};
